//import { addlist } from './modules/addlist';
import { narrowDown } from './modules/narrowDown';
import { tabletViewport } from './modules/tabletViewport';
import { jsScroll } from './modules/jsScroll';
import { smoothScroll } from './modules/smoothScroll';
import { jqPagetop } from './modules/jqPagetop';

//addlist();
narrowDown();
tabletViewport();
jsScroll();
smoothScroll();
jqPagetop();